exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status-panel[data-v-4b1ad6b5]{align-items:center;border:1px solid #d8dee8;border-radius:6px;display:flex;justify-content:space-between;min-height:54px;padding:10px 12px}.status-panel>span[data-v-4b1ad6b5]{color:#26364a;font-size:13px;font-weight:700}", ""]);

// exports
